// remove this file from core
import {keys, forEach, includes, intersection, pick, remove, union, uniq, assign} from "lodash-es";
import { BaseVariableService, AppInjector } from "@wms/variables";
import { VARIABLE_CONSTANTS } from './config';
import {AppRef} from "@wms/design-container";
import {PreferenceService} from "@wms/services";
import {runtimeEventManager} from "@wm/core";

let variableConfig: any = {
  "wm.LiveVariable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE],
    "category": "wm.LiveVariable",
    "defaultName": "databaseVariable",
    "spinnerInFlight": true,
    "newVariableKey": "New Variable"
  },
  "wm.CrudVariable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI],
    "category": "wm.CrudVariable",
    "defaultName": "crudVariable",
    "spinnerInFlight": true,
    "newVariableKey": "New Variable"
  },
  "wm.ServiceVariable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE_API, VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.WEB, VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.JAVA, VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.SECURITY],
    "category": "wm.ServiceVariable",
    "defaultName": "serviceVariable",
    "spinnerInFlight": true,
    "newVariableKey": "New Variable"
  },
  "wm.WebSocketVariable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.WEB],
    "category": "wm.WebSocketVariable",
    "defaultName": "webSocketVariable",
    "methods": ['open', 'send', 'close'],
    "newVariableKey": "New Variable"
  },
  "wm.Variable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.CUSTOM],
    "category": "wm.Variable",
    "defaultName": "staticVariable",
    "hideInEvents": true
  },
  "wm.DeviceVariable": {
    "collectionType": "data",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DEVICE],
    "category": "wm.DeviceVariable",
    "defaultName": "deviceVariable",
    "spinnerInFlight": true,
    "newVariableKey": "New Variable"
  },
  "wm.NavigationVariable": {
    "collectionType": "action",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.NAVIGATION],
    "category": "wm.NavigationVariable",
    "defaultName": "navigationAction",
    "newVariableKey": "New Action"
  },
  "wm.LoginVariable": {
    "collectionType": "action",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.LOGIN],
    "category": "wm.LoginVariable",
    "defaultName": "loginAction",
    "appOnly": true,
    "spinnerInFlight": true,
    "newVariableKey": "New Action",
    "hideInEvents": true
  },
  "wm.LogoutVariable": {
    "collectionType": "action",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.LOGOUT],
    "category": "wm.LogoutVariable",
    "defaultName": "logoutAction",
    "appOnly": true,
    "spinnerInFlight": true,
    "newVariableKey": "New Action",
    "hideInEvents": true
  },
  "wm.TimerVariable": {
    "collectionType": "action",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.TIMER],
    "category": "wm.TimerVariable",
    "defaultName": "timerAction",
    "newVariableKey": "New Action"
  },
  "wm.NotificationVariable": {
    "collectionType": "action",
    "serviceTypes": [VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.NOTIFICATION],
    "category": "wm.NotificationVariable",
    "defaultName": "notificationAction",
    "newVariableKey": "New Action"
  }
}


export function retrieveEventCallbackVariables(variableName?: string, context?: any) {

  let parents: any = {
    'wm-page': {},
    'wm-button': {}
  }



  let variableArray: any = [],
    methods,
    varCollection: any = getAll(),
    contextsVariables = context ? [varCollection[context]] : [varCollection[VARIABLE_CONSTANTS.OWNER.APP], varCollection[getActivePageName()]];

  // if ($rootScope.isPrefabTemplate) {
  //     contextsVariables = [varCollection.Main];
  // }
  /*iterating over variable collection*/
  forEach(contextsVariables, function (variables) {
    forEach(variables, function (curVariable, curVariableName) {
      if (isEventCallbackVariable(curVariable.category)) {
        /*checking if current variable name is not equal to the variable name provided.*/
        if (!variableName || curVariableName !== variableName) {
          methods = variableConfig[curVariable.category].methods;
          variableArray.push({ name: curVariableName, category: curVariable.category, methods: methods, serviceType: getVariableServiceType(curVariable) });
        }
      }
    });
  });
  return uniq(variableArray);
}

export function isSpinnerType(category: string) {
  return variableConfig[category].spinnerInFlight;
}

export function isEventCallbackVariable(category: string): any {
  let retVal = false;
  if (category !== "wm.Variable") {
    retVal = true;
  }
  return retVal;
}

export function getVariableServiceType(variableObject: any) {
  let category = variableObject.category,
    serviceType = getServiceTypesByCategory(category);
  if (serviceType.length === 1) {
    serviceType = serviceType[0];
  } else {
    switch (category) {
      case 'wm.LiveVariable':
        serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE;
        break;
      case 'wm.CrudVariable':
      case 'wm.ServiceVariable':
        if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA) {
          serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.DATABASE_API;
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_JAVA) {
          serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.JAVA;
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_SECURITY) {
          serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.SECURITY;
        } else if (variableObject.serviceType === VARIABLE_CONSTANTS.SERVICE_TYPE_OPEN_API) {
          serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.OPENAPI;
        } else {
          serviceType = VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.WEB;
        }
        break;
      default:
        serviceType = serviceType[0];
    }
  }
  return serviceType;
}

export function getServiceTypesByCategory(category: string) {
  return variableConfig[category].serviceTypes;
}

export function getVariableByName(variableName: string, scope?: any) {
  let variables: any = getAll(),
    scopes,
    i,
    n;

  /* if scope provided, return the variable in that scope */
  if (scope) {
    let variableData = scope.Variables[variableName];
    if (variableData) {
      return variableData;
    }
  }

  /* in Run Mode, find and return the variable against active page or app */
  // if (CONSTANTS.isRunMode) {
  //   scope = pageScopeMap[$rootScope.activePageName];
  //   if (scope && variables[scope.$id][variableName]) {
  //     return variables[scope.$id][variableName];
  //   }
  //   scope = pageScopeMap[VARIABLE_CONSTANTS.OWNER.APP];
  //   if (scope && variables[scope.$id][variableName]) {
  //     return variables[scope.$id][variableName];
  //   }
  //   /* case of searching a partial's variable, partial being loaded in a page */
  //   for (i = 0, scopes = Object.keys(variables), n = scopes.length; i < n; i += 1) {
  //     scope = scopes[i];
  //     if (variables[scopes[i]][variableName]) {
  //       return variables[scopes[i]][variableName];
  //     }
  //   }
  // }

  if (!variables) {
    return;
  }

  /* return the variable against active page or app (In studio mode, this is the writable variable obejct */
  return (variables[getActivePageName()] && variables[getActivePageName()][variableName]) || (variables[VARIABLE_CONSTANTS.OWNER.APP] && variables[VARIABLE_CONSTANTS.OWNER.APP][variableName]) || null;
}

export function getVariableByNames(variableName: string, scope?: any) {
  // activePageName='Main'
  // let variables:any = variableCollection,
  //   scopes,
  //   i,
  //   n;

  /* if scope provided, return the variable in that scope */
  // if (scope) {
  // return (variables[scope.$id] && variables[scope.$id][variableName]) || variableCollection[$rootScope.$id][variableName];
  // }

  /* in Run Mode, find and return the variable against active page or app */
  // if (CONSTANTS.isRunMode) {
  //   scope = pageScopeMap[$rootScope.activePageName];
  //   if (scope && variables[scope.$id][variableName]) {
  //     return variables[scope.$id][variableName];
  //   }
  //   scope = pageScopeMap[VARIABLE_CONSTANTS.OWNER.APP];
  //   if (scope && variables[scope.$id][variableName]) {
  //     return variables[scope.$id][variableName];
  //   }
  //   /* case of searching a partial's variable, partial being loaded in a page */
  //   for (i = 0, scopes = Object.keys(variables), n = scopes.length; i < n; i += 1) {
  //     scope = scopes[i];
  //     if (variables[scopes[i]][variableName]) {
  //       return variables[scopes[i]][variableName];
  //     }
  //   }
  // }

  // if (!variables) {
  //   return;
  // }
  //
  // console.log('hi')
  // return;
  /* return the variable against active page or app (In studio mode, this is the writable variable obejct */
  // return (variables[activePageName] && variables[activePageName][variableName]) || (variables[VARIABLE_CONSTANTS.OWNER.APP] && variables[VARIABLE_CONSTANTS.OWNER.APP][variableName]) || null;
}

export function isActionTypeVariable(variable: any) {
  let serviceType = getVariableServiceType(variable),
    actionServiceTypes: any = getServiceTypesByCollectionType('action');
  return includes(actionServiceTypes, serviceType);
}

/* function to return variable category list to populate in filter dropdowns */
export function getVariableCategoryList(collectionType: any, getKeysList?: any) {
  const appRef = AppInjector.get(AppRef);
  let categoryList: any = {},
    isPrefabProject = appRef.isPrefabType,
    filteredVariables: any = [];

  if (!isPrefabProject) {
    forEach(variableConfig, function (variable) {
        if (!collectionType || collectionType.toLowerCase() === 'all' || variable.collectionType === collectionType) {
            filteredVariables.push(variable);
        }
    });
  } else {
    forEach(variableConfig, function (variable) {
        if (!variable.appOnly && (!collectionType || collectionType.toLowerCase() === 'all' || variable.collectionType === collectionType)) {
            filteredVariables.push(variable);
        }
    });
  }
  forEach(filteredVariables, function (variable) {
    categoryList[variable.category] = variable.category;
  });

  if (getKeysList) {
    categoryList = Object.keys(categoryList);
  }
  return categoryList;
}

/**
 * @ngdoc method
 * @name $Variables#getByContext
 * @methodOf wm.variables.$Variables
 * @description
 * Gets variables for specified contextx
 */
export function getByContext(pages: any) {
  let varCollection: any = getAll();
  return pick(varCollection, pages);
}

/**
   * @ngdoc method
   * @name $Variables#getDuplicateVariables
   * @methodOf wm.variables.$Variables
   * @description
   * Get array of duplicate variable names
   */
export function getDuplicateVariables() {
  let varCollection: any = getAll();
  return intersection(keys(varCollection[VARIABLE_CONSTANTS.OWNER.APP]), keys(varCollection[getActivePageName()]));
}

export function getServiceTypesByCollectionType(collectionType: any) {
  const appRef = AppInjector.get(AppRef),
        preferencesService = AppInjector.get(PreferenceService);
  let projectService = runtimeEventManager.getService('projectService');
  let serviceTypes: any[] = [],
      isPrefabProject = appRef.isPrefabType,
      preferences = preferencesService.get(),
      filteredVariables: any[] = [],
      project = projectService.getDetails();

  if (!isPrefabProject) {
    forEach(variableConfig, function (variable) {
      if (!collectionType || collectionType.toLowerCase() === 'all' || variable.collectionType === collectionType) {
        filteredVariables.push(variable);
      }
    });
  } else {
    forEach(variableConfig, function (variable) {
      if (!variable.appOnly && (!collectionType || collectionType.toLowerCase() === 'all' || variable.collectionType === collectionType)) {
        filteredVariables.push(variable);
      }
      if (variable.category === 'wm.ServiceVariable' || variable.category === 'wm.CrudVariable') {
        let securityIndex = variable.serviceTypes.indexOf(VARIABLE_CONSTANTS.VARIABLE_SERVICE_TYPES.SECURITY);
        if (securityIndex !== -1) {
          variable.serviceTypes.splice(securityIndex, 1);
        }
      }
    });
  }
  forEach(filteredVariables, function (variable) {
    //checking for RBAC permissions. show only those services which are allowed
    remove(variable.serviceTypes, function (serviceType): any {
      if (serviceType === 'database' || serviceType === 'databaseapi') {
        return !preferences.project.database.create;
      }
      if (serviceType === 'web') {
        return !preferences.project.rest.create || !preferences.project.soap.create || !preferences.project.websocket.create;
      }
      if (serviceType === 'java') {
        return !preferences.project.javaservice.create;
      }
    });
    serviceTypes = union(serviceTypes, variable.serviceTypes);
  });
  return serviceTypes;
}

export function getAll() {
  const variableService = AppInjector.get(BaseVariableService);
  return variableService.getVariableCollection();
}

export function addVariableConfig(config: any) {
  let key = config['category'];
  if (key)
  variableConfig[key] = config;
}

export function getVariableConfig() {
  return variableConfig;
}

export function getStudioCopy(pages?: any) {
  const variableService = AppInjector.get(BaseVariableService);
  const studioCopy = variableService.getStudioCopy();
  if (pages && pages.length) {
    return pick(studioCopy, pages);
  }
  return studioCopy;
}

export function getActivePageName () {
  const variableService = AppInjector.get(BaseVariableService);
  return variableService.pageService.activePageName;
}

